import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "print-hidden flex justify-center w-full py-6 border-b border-gray-200" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", null, "ログイン情報を印刷", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_m_button, {
      color: "primary-500",
      "hover-color": "primary-600",
      class: "mr-2",
      onClick: _ctx.print
    }, {
      default: _withCtx(() => [
        _createVNode(_component_m_icon, {
          type: "printer",
          class: "mr-2"
        }),
        _hoisted_2
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_m_button, {
      color: "primary-500",
      "hover-color": "primary-600",
      class: "ml-2",
      onClick: _ctx.messageCopy
    }, {
      default: _withCtx(() => [
        _createVNode(_component_m_icon, {
          type: _ctx.clipboardStatusType,
          class: "mr-2"
        }, null, 8, ["type"]),
        _createVNode("span", null, _toDisplayString(_ctx.clipboardMessage), 1)
      ]),
      _: 1
    }, 8, ["onClick"]),
    (_ctx.isStartLearningBtnShown)
      ? (_openBlock(), _createBlock(_component_m_button, {
          key: 0,
          color: "primary-500",
          "hover-color": "primary-600",
          class: "ml-4"
        }, {
          default: _withCtx(() => [
            _createVNode("a", {
              href: _ctx.startLearningLink,
              target: "_blank",
              rel: "noopener noreferrer"
            }, "学習スタート方法を印刷", 8, ["href"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}